export class Mission {
    libelle: string;
    type_mission_id: string;
    objet: string;
    date_debut: any;
    date_fin: any;
    //no_recommandation: any;
    reference: any;
    mission_id: any

    private errorMessage: string;
  
    constructor() {
      this.errorMessage = "";
    }
  
    // Get error message
    getErrorMessage(): string {
      return this.errorMessage;
    }
  
    // Check for save
    canSave(): boolean {
  
      if (this.libelle === undefined || this.libelle === null || this.libelle.trim() === "") {
        this.errorMessage = "Veuillez saisir le libellé";
        return false;
      }
  
      if (this.type_mission_id === undefined || this.type_mission_id === null) {
        this.errorMessage = "Veuillez sélectionner le type de mission";
        return false;
      }
  
      if (this.date_debut === undefined || this.date_debut === null) {
        this.errorMessage = "Veuillez saisir la date de début de la mission";
        return false;
      }

     if (this.date_fin === undefined || this.date_fin === null) {
        this.errorMessage = "Veuillez saisir la date de fin de la mission";
        return false;
      }

      if (this.date_fin <  this.date_debut) {
        this.errorMessage = "La date de fin de la mission doit être ultérieure à la date de début";
        return false;
      }

      

       if (this.objet === undefined || this.objet === null || this.objet.trim() === "") {
        this.errorMessage = "Veuillez saisir l'objet de la mission'";
        return false;
      }
  
      this.errorMessage = "";
      return true;
    }//end canSave

}